.statusContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 2px 7px;
  border-radius: 6px;
  color: var(--sentiment-text-neutral);
  background: var(--sentiment-background-neutral);
  width: fit-content;
}

.listed {
  background: var(--sentiment-background-positive);
  color: var(--sentiment-text-positive);
}

.pending {
  background-color: var(--sentiment-background-notice);
  color: var(--sentiment-text-notice);
}

.error {
  background: var(--sentiment-background-negative);
  color: var(--sentiment-text-negative);
  transition: 0.3s ease;
  opacity: 1;
  cursor: pointer;
}
.error:hover {
  opacity: 0.66;
  transition: 0.3s ease;
}

.loader::before, .loader::after {
  border-color: var(--sentiment-text-notice);
}

.modal {
  min-width: 60rem;
}